import { HeadingRow } from "cai-fusion";
import { useEffect, useState } from "react";
import { useDataStore } from "../contexts/DataStoreContext";
import { useTransientVisibility } from "../../fusion/Contexts/VisualContext";

import EditTextNoteDrawer from "../overlay/editTextNoteDrawer";

import { ReactComponent as IconAdd } from "../../../images/icon-add.svg";
import { ReactComponent as IconFileOutline } from "../../../images/icon-file-outline.svg"
import { ReactComponent as IconTrash } from "../../../images/icon-trash.svg";
import { ReactComponent as IconDraft } from "../../../images/icon-draft.svg";
import { ReactComponent as RippleLoading } from "../../../images/ripple-loading.svg";

const DataStoreTextNotes = () => {

    const { textNotes, setTextNote } = useDataStore();
    const { show } = useTransientVisibility();

    const onCreate = () => {
        setTextNote({"title": "New Text Note", "content": "", "isCreating": true});
        show('EditTextNoteDrawer');
    }
    
    return (
        <>
            <HeadingRow
                className="m-heading-row--secondary"
                title="Text Notes"
                size={3}
            >
                <div className="m-icon-row m-icon-row--right-align">
                    <button className="a-icon-link m-icon-row__icon" onClick={onCreate}>
                        <div className="a-icon-link__inner">
                            <div className="a-icon-link__icon-wrapper">
                                <IconAdd className="a-icon-link__icon" />
                            </div>
                            <span className="a-icon-link__text">Add Text Note</span>
                        </div>
                    </button>
                </div>
            </HeadingRow>
            <div className="row">
                <div className="col-12">
                    <div className="o-block">
                        { textNotes.length === 0 
                        ?   <div className="col-md-12 text-center l-mt-xs" aria-colspan={4}>
                                <p className="a-muted-text">You have no text notes for this data collection.</p>   
                            </div>
                        :   <table className="o-treegrid o-treegrid--compact l-mr-sm">
                                <colgroup className="o-treegrid__colgroup">
                                    <col className="o-treegrid__col o-treegrid__col--48" span={1} />
                                    <col className="o-treegrid__col o-treegrid__col--large" span={1} />
                                    <col className="o-treegrid__col o-treegrid__col--48" span={1} />
                                </colgroup>
                                <tbody>
                                    { textNotes.sort((a, b) => a.name.localeCompare(b.name)).map((note) => (
                                        <TextNoteItem key={note.id ?? "tempname"} noteObj={note} />
                                    ))}
                                </tbody>
                            </table>
                        }
                    </div>
                </div>
            </div>
            <EditTextNoteDrawer />
        </>
    )
}

const TextNoteItem = ({noteObj}) => {

    const { fetchTextNoteItem, deleteTextNote } = useDataStore();
    const { show } = useTransientVisibility();

    const editTextNote = async () => {
        await fetchTextNoteItem(noteObj.id);
        show('EditTextNoteDrawer');
    }

    return (
        <tr className="o-treegrid__row o-treegrid__row--shown">
            <td className="o-treegrid__cell">
                <span className="a-icon">
                    { noteObj.isLoading ?
                        <RippleLoading className="a-icon__img" style={{maxHeight: 50}}/> :
                        <IconFileOutline className="a-icon__img" />
                    }
                </span>
            </td>
            <td className="o-treegrid__cell">
                <span className="a-subtle-text">
                    <strong>{noteObj.name}</strong>
                </span>
            </td>
            <td className="o-treegrid__cell">
                { !noteObj.isLoading &&
                    <div className="m-button-row">
                        <button className="a-icon-link" onClick={editTextNote}>
                            <div className="a-icon-link__inner">
                                <div className="a-icon-link__icon-wrapper">
                                    <IconDraft className="a-icon-link__icon" />
                                </div>
                            </div>
                        </button>
                        <button className="a-icon-link a-icon-link--destructive" onClick={() => deleteTextNote(noteObj.id)}>
                            <div className="a-icon-link__inner">
                                <div className="a-icon-link__icon-wrapper">
                                    <IconTrash className="a-icon-link__icon" />
                                </div>
                            </div>
                        </button>
                    </div>
                }
            </td>
        </tr>
    )
}

export default DataStoreTextNotes;